// extracted by mini-css-extract-plugin
export var header = "_wv-1";
export var maskBottom = "_wv-6";
export var maskMiddle = "_wv-7";
export var maskTop = "_wv-5";
export var root = "_wv-0";
export var scrollDownButton = "_wv-3";
export var scrollDownButtonHidden = "_wv-4";
export var viewport = "_wv-2";